import './initi18n';
import './app/main';
import './urls';

// common
import './common/before-start';
import './common/polyfill';
import './common/controllers/auth/baseAuth';
import './common/directives/';
import './common/filters/';
import './common/listeners/';
import './common/modules/debug';
import './common/repositories/';
import './common/repositoryProcessors/';
import './common/resolvers/';
import './common/services/';

// // dashboard
import './controllers/';
import './directives/';
import './filters/';
import './modules/';
import './restServices/';
import './services/';

// react components
import './react/registerDirectives';



// WEBPACK FOOTER //
// ./scripts/index.js